import type { ReactNode } from 'react';

import type { CacheProps } from '../types';

/**
 * Cache setting for persisting column sizing and sorting to localStorage.
 *
 * @example
 * ```tsx
 * <DataTable.Cache properties={['sizing', 'sorting']} />
 * ```
 */
export const Cache = (_props: CacheProps): ReactNode => {
  return null;
};

Cache.displayName = 'DataTable.Cache';
